/* import __COLOCATED_TEMPLATE__ from './question.hbs'; */
import { PRESCREENER_CLIENT_TYPES } from 'client-portal/utils/prescreener/constants';
import { service } from '@ember/service';
import Component from '@glimmer/component';

const HALF_ROW = 6;
const FULL_ROW = 12;

export default class RequestPrescreenerQuestion extends Component {
  @service prescreener;

  get question() {
    return this.args.question;
  }

  get itemStylePrefix() {
    return this.args.itemStylePrefix;
  }

  get itemStyleSuffix() {
    return this.question?.defaultQuestion ? HALF_ROW : FULL_ROW;
  }

  get itemStyles() {
    return this.itemStylePrefix ? `${this.itemStylePrefix}${this.itemStyleSuffix}` : '';
  }

  get clientType() {
    return this.args.clientType || PRESCREENER_CLIENT_TYPES.client;
  }

  get validationModel() {
    return this.prescreener.validation.getValidatedAnswerModel(this.question, this.clientType);
  }

  get isInvalid() {
    const validation = this.validationModel?.validations?.attrs?.value;
    return validation?.isInvalid && this.showForcedValidation;
  }

  get showForcedValidation() {
    return this.prescreener.validation.forceValidation;
  }

  get isClientTypeAware() {
    return this.question?.isClientTypeAware;
  }

  get canShowForContactForm() {
    return this.question?.showToContact && this.args.isForContact;
  }

  get canShowForCoupleForm() {
    return this.question?.showToCouple && this.args.isForCouple;
  }

  get showForContact() {
    return this.canShowForContactForm && this.clientType === PRESCREENER_CLIENT_TYPES.contact;
  }

  get showForCouple() {
    return this.canShowForCoupleForm && this.clientType === PRESCREENER_CLIENT_TYPES.partner;
  }

  get showForClient() {
    return (
      !this.isClientTypeAware ||
      this.clientType === PRESCREENER_CLIENT_TYPES.client ||
      this.canShowForContactForm ||
      this.canShowForCoupleForm
    );
  }

  get shouldShowForClientType() {
    return this.showForClient || this.showForContact || this.showForCouple;
  }
}
